const enum ContestStatus {
  SCHEDULED = 'SCHEDULED',
  IN_PROGRESS = 'IN_PROGRESS',
  FINISHED = 'FINISHED',
  FINALIZED = 'FINALIZED',
  CANCELLED = 'CANCELLED',
}

export { ContestStatus };
